import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardHeader,
} from "reactstrap";

import * as XLSX from "xlsx";

import "react-calendar/dist/Calendar.css";
import { api } from "../../../../api";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const MaterialReturn = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData2, setFilteredData2] = useState([]);
  const [originalData2, setOriginalData2] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`crudReturnStock.php?company_id=${company_id}`);
        const products = response.data;
        setOriginalData(products); // Store original data
        setFilteredData(products); // Initially set filtered data to original data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`addDeliveryStock.php?company_id=${company_id}`);
        const products = response.data;
        setOriginalData2(products);
        setFilteredData2(products);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleDeleteIconClick = (item_id) => {
    setItemToDelete(item_id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirmation = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.delete(`crudReturnStock.php?company_id=${company_id}`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ return_id: itemToDelete }),
      });
      console.log(response.data);
      window.location.reload(); // Reload the page after deletion
    } catch (error) {
      console.error("Error deleting item:", error);
    }
    setItemToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const [showRoleModal, setShowRoleModal] = useState(false);
  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
  };

  const [role, setrole] = useState();

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);

  const [entriesToShow, setEntriesToShow] = useState(5);
  const [dataToShow, setDataToShow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredData.length / entriesToShow);

  useEffect(() => {
    setDataToShow(
      filteredData.slice(
        (currentPage - 1) * entriesToShow,
        currentPage * entriesToShow
      )
    );
  }, [entriesToShow, currentPage, filteredData]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? filteredData.length : Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  const handleDownload = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "stock_list";

    const formattedData = dataToShow.map((item) => ({
      "Product Id": item.product_id,
      "Product Name": item.product_name,

      "Quantity Returned": item.quantity_returned,
      "Yet To Returned": item.yet_to_returned,
      "Return Date": item.return_date,
      "Return By": item.returned_by,
      "Material Tracking Number": item.material_tracking_number,
      // Cost: item.cost,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Product Id",
        "Product Name",
        "Quantity Returned",
        "Yet To Returned",
        "Return Date",
        "Return By",
        "Material Tracking Number",
      ],
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock List");

    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => {
        ws[key].s = headerCellStyle;
      });

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const excelData = new Blob([excelBuffer], { type: fileType });

    const excelUrl = URL.createObjectURL(excelData);

    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();

    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const [addstock, setAddStock] = useState({
    product_name: "",
    quantity_returned: "",
    yet_to_returned: "",
    return_date: "",
    returned_by: "",
    material_tracking_number: "",
    
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setAddStock((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };
      console.log("Updated form state:", updatedState); // ✅ Correct value here
      return updatedState;
    });
  };

  const handleFormSubmit = async (event) => {
    // event.preventDefault();

    const formDataToSend = {
      product_name: addstock.product_name,
      quantity_returned: addstock.quantity_returned,
      yet_to_returned: addstock.yet_to_returned,
      return_date: addstock.return_date,
      returned_by: addstock.returned_by,
      material_tracking_number: addstock.material_tracking_number,
    };

    try {
      const company_id = Cookies.get('company_id');
      const response = await api.post(`crudReturnStock.php?company_id=${company_id}`, formDataToSend);
      console.log("Data sent successfully:", response.data);
      // Optionally reload or reset
      // window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredData(originalData);
    } else {
      const filteredResults = originalData.filter(
        (item) =>
          item.product_name &&
          item.product_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filteredResults);
    }
  }, [searchQuery, originalData]);
  console.log(dataToShow);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <div className="header bg-gradient-info py-5">
            <Container fluid>
              <Row className="mb-5">
                <Col
                  xs="12"
                  className="d-flex justify-content-between align-items-center flex-wrap"
                >
                  <Form className="navbar-search navbar-search-dark form-inline w-100 mb-3 mb-md-0">
                    <FormGroup className="mb-0 w-100">
                      <InputGroup className="input-group-alternative w-70">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                          <Input
                            placeholder="Search Stock"
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-100" // Adjust width of input field
                          />
                        </InputGroupAddon>
                      </InputGroup>
                      {/* Add margin to the button */}
                      <div className="ml-3">
                        <Button onClick={toggleRole}>
                          Add Return Materials
                        </Button>
                      </div>
                    </FormGroup>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
          <Row className="">
            <Col xl="12" style={{ marginTop: "-20px" }}>
              <Card className="shadow">
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">Stock List</h3>
                      </div>
                      <div className="col text-right">
                        <Dropdown
                          isOpen={projectDropdownOpen}
                          toggle={toggleProjectDropdown}
                        >
                          <DropdownToggle caret>
                            Show Entries:{" "}
                            {entriesToShow === filteredData.length
                              ? "All"
                              : entriesToShow}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              onClick={() => handleEntriesChange(5)}
                            >
                              5
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleEntriesChange(10)}
                            >
                              10
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleEntriesChange(50)}
                            >
                              50
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleEntriesChange("All")}
                            >
                              All
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                        <button
                          className="btn btn-success mr-2"
                          onClick={handleDownload}
                        >
                          Download
                        </button>
                      </div>
                    </Row>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity Returned</th>
                        <th scope="col">Yet To Return</th>
                        <th scope="col">Returned Date</th>
                        <th scope="col">Returned By</th>
                        <th scope="col">Returned Material Tracking ID</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {dataToShow.map((item, index) => (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td>{item.product_name}</td>
                          <td>{item.quantity_returned}</td>
                          <td>{item.yet_to_returned}</td>
                          <td>{item.return_date}</td>
                          <td>{item.returned_by}</td>
                          <td>{item.material_tracking_number}</td>
                          <td
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <Link
                              to={`/store-admin/store-management/editMaterialReturn/${item.product_id}`}
                              style={{ marginRight: "10px" }}
                            >
                              <i
                                className="fa-solid fa-pen"
                                style={{
                                  fontSize: "23px",
                                  color: "green",
                                  cursor: "pointer",
                                }}
                              ></i>
                            </Link>
                            <i
                              className="fa fa-trash"
                              style={{
                                fontSize: "23px",
                                color: "red",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleDeleteIconClick(item.return_id)
                              }
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={prePage}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={nextPage}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            isOpen={showDeleteConfirmation}
            toggle={() => setShowDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>Are you sure you want to delete this product?</ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteConfirmation}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>
          <Modal isOpen={showRoleModal} toggle={toggleRole}>
            <ModalHeader toggle={toggleRole}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                New Material Return
              </h2>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleFormSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="product_name"
                    >
                      Enter Product Name
                    </label>
                    <select
                      name="product_name"
                      value={addstock.product_name}
                      className="form-select form-control-alternative custom-select"
                      id="product_name"
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled>
                        Select Product
                      </option>
                      {originalData2.map((item, index) => (
                        <option key={index} value={item.product_name}>
                          {item.product_name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="quantity_returned"
                    >
                      Enter Quantity Returned
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="quantity_returned"
                      type="number"
                      name="quantity_returned"
                      value={addstock.quantity_returned}
                      onChange={handleInputChange}
                      placeholder="Enter Quantity Returned"
                      required
                    />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="yet_to_returned"
                    >
                      Enter Quantity Yet To Return
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="yet_to_returned"
                      type="number"
                      name="yet_to_returned"
                      value={addstock.yet_to_returned}
                      onChange={handleInputChange}
                      placeholder="Enter Quantity Yet To Return"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="return_date">
                      Enter Return Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="return_date"
                      type="date"
                      name="return_date"
                      value={addstock.return_date}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="returned_by">
                      Enter Returned By
                    </label>
                    <select
                      name="returned_by"
                      value={addstock.returned_by}
                      className="form-select form-control-alternative custom-select"
                      id="returned_by"
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled>
                        Select Returned By
                      </option>
                      {[
                        ...new Set(
                          originalData2.map((item) => item.delivered_to_name)
                        ),
                      ].map((name, idx) => (
                        <option key={idx} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="returned_by">
                      Enter Returned Material Tracking Id
                    </label>
                    <select
                      name="material_tracking_number"
                      value={addstock.material_tracking_number}
                      className="form-select form-control-alternative custom-select"
                      id="material_tracking_number"
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled>
                        Select Returned By
                      </option>
                      {[
                        ...new Set(
                          originalData2.map((item) => item.material_tracking_number)
                        ),
                      ].map((name, idx) => (
                        <option key={idx} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>

                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default MaterialReturn;
